import moment from 'moment';
import { FiMoreHorizontal } from 'react-icons/fi';
import usePermission from '@/hooks/usePermission';
import { t } from 'i18next';
import { useClient } from 'jsonapi-react';
import { ModalWarning } from '@/components/custom/modal/modal-warning';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { Link } from 'react-router-dom';
import { TableCell, TableRow } from '@/components/ui/table';
import { IconWrapper } from '@/components/custom/icon';
import { Badge } from '@/components/ui/badge';
import { FormCheck } from '@/components/custom/form';
import { BulletinBoardBannerTitle, BulletinBoardImg, BulletinBoardProfiles } from '@/components/custom/bulletin-board';

export const BulletinBoardsRow = ({ banner, setOpenDetailsModal, setSelectedBanner, updateBannerStatus, updateList }) => {
  const client = useClient();
  const [showWarning, setShowWarning] = useState(false);

  const handleDelete = async id => {
    try {
      const { error } = await client.delete(`bulletin_boards/${id}`);
      if (error) {
        toast.error(t('bulletinBoards.errorDeleteBanner'));
      } else {
        toast.success(t('bulletinBoards.successDeleteBanner'));
        updateList();
      }
    } catch (error) {
      toast.error(t('bulletinBoards.errorDeleteBanner'));
      console.error(error);
    }
    setShowWarning(false);
  };

  const handlePublish = async id => {
    const payload = {
      'published-at': banner['published-at'] ? null : new Date().toISOString()
    };

    try {
      const { error } = await client.mutate(`bulletin_boards/${id}`, payload, {
        method: 'PUT'
      });
      if (error) {
        banner['published-at'] ? toast.error(t('bulletinBoards.errorUnpublishingBanner')) : toast.error(t('bulletinBoards.errorPublishingBanner'));
      } else {
        banner['published-at'] === null ? toast.success(t('bulletinBoards.successPublishingBanner')) : toast.success(t('bulletinBoards.successUnpublishingBanner'));
        updateBannerStatus(banner.id, payload['published-at']);
      }
    } catch (error) {
      toast.error(t('bulletinBoards.errorPublishingBanner'));
      console.error(error);
    }
  };

  return (
    <>
      <TableRow>
        <TableCell>
          <div className="flex items-center gap-6">
            <BulletinBoardImg
              src={banner?.image?.url}
              alt={banner.title}
            />
            <BulletinBoardBannerTitle>{banner.title}</BulletinBoardBannerTitle>
          </div>
        </TableCell>
        <TableCell>
          {moment(banner['start-date']).format('DD/MM/YYYY')} a {moment(banner['end-date']).format('DD/MM/YYYY')}
        </TableCell>
        <TableCell>
          {banner.profiles.length > 2 ? (
            <BulletinBoardProfiles>
              <BulletinBoardProfiles>
                {banner.profiles
                  .slice(0, 2)
                  .map(profile => profile.name)
                  .join(', ')}{' '}
              </BulletinBoardProfiles>

              <Badge
                variant="more"
                size="xs"
                className="font-bold"
                title={`${banner.profiles
                  .slice(2)
                  .map(profile => profile.name)
                  .join(', ')}`}
              >{`+ ${banner.profiles.length - 2}`}</Badge>
            </BulletinBoardProfiles>
          ) : (
            <BulletinBoardProfiles>{banner.profiles.map(profile => profile.name).join(', ')}</BulletinBoardProfiles>
          )}
        </TableCell>
        <TableCell>
          <FormCheck
            label={banner['published-at'] ? 'Publicado' : 'Despublicado'}
            checked={!!banner['published-at']}
            onCheckedChange={() => handlePublish(banner.id)}
          />
        </TableCell>
        <TableCell>
          <DropdownMenu>
            <DropdownMenuTrigger>
              <IconWrapper size="sm">
                <FiMoreHorizontal size={16} />
              </IconWrapper>
            </DropdownMenuTrigger>

            <DropdownMenuContent align="end">
              {usePermission('Editar Mural', 'Mural') ? (
                <DropdownMenuItem asChild>
                  <Link to={`/banners/novo/${banner?.id}`}>{t('button.edit')}</Link>
                </DropdownMenuItem>
              ) : null}
              <DropdownMenuItem
                onSelect={() => {
                  setOpenDetailsModal(true);
                  setSelectedBanner(banner);
                }}
              >
                {t('button.view')}
              </DropdownMenuItem>
              {usePermission('Excluir Mural', 'Mural') ? (
                <DropdownMenuItem
                  className="text-danger"
                  onSelect={() => setShowWarning(true)}
                >
                  {t('button.delete')}
                </DropdownMenuItem>
              ) : null}
            </DropdownMenuContent>
          </DropdownMenu>
        </TableCell>
      </TableRow>

      <ModalWarning
        show={showWarning}
        titleFirstButton="Sim"
        titleSecondButton="Não"
        onClose={() => setShowWarning(false)}
        title={'Você tem certeza que deseja excluir?'}
        description={'Essa ação não poderá ser desfeita'}
        onSubmitFirstButton={() => handleDelete(banner.id)}
        onSubmitSecondButton={() => setShowWarning(false)}
      />
    </>
  );
};
